import React, { Component } from 'react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { Form, Input, Button, FormInstance } from 'antd';

import styles from './index.module.less';

const { Item } = Form;

export interface ResetPasswordPanelProps extends RouteComponentProps {
  onReset: (data: any) => void;
  loading: boolean;
}
class ResetPasswordPanel extends Component<ResetPasswordPanelProps> {
  form: FormInstance | null = null;
  reset = () => {
    this.form?.validateFields().then((formData: any) => {
      const { email } = formData;
      const { onReset } = this.props;
      onReset({
        ...formData,
        email: email.toLowerCase(),
      });
    });
  };

  render() {
    const { loading, location } = this.props;
    // const layout = {
    //   labelCol: {
    //     span: 0,
    //   },
    //   wrapperCol: {
    //     span: 24,
    //   },
    // };
    return (
      <div className={styles.reset_password_panel}>
        <div className={styles.title}>Reset Password</div>
        <div className={styles.form}>
          <Form
            layout={'vertical'}
            ref={me => (this.form = me)}
            // onFinish={this.onFinish}
          >
            <Item
              name="email"
              label="Fill in your email to get a verification code."
              validateTrigger={'onBlur'}
              rules={[
                {
                  required: true,
                  message: 'Please input your email',
                },
                {
                  type: 'email',
                  message: 'Invalid email address, please check',
                },
              ]}
            >
              <Input
                placeholder={'Enter email'}
                maxLength={50}
                size={'large'}
              />
            </Item>
            <Item>
              <Button
                type="primary"
                block
                onClick={this.reset}
                loading={loading}
                size={'large'}
              >
                Get Verification Code
              </Button>
            </Item>
          </Form>
          <div className={styles.footer}>
            <div className={styles.text}>
              Already have an account?&nbsp;
              <Link
                to={{ pathname: '/login', search: location.search }}
                className={styles.link}
              >
                Sign in
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(ResetPasswordPanel);
